import { Redirect, Route, Switch } from 'react-router-dom';
import Admin from './index';
import { Layout } from 'antd';
import Login from './Login/login';
import { useState, useEffect } from 'react';

function MainPage() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [currentPath, setCurrentPath] = useState('/admin/dashboard');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const accessToken = localStorage.getItem('accessToken');
    setIsAuthenticated(!!accessToken);
    setLoading(false);
  }, []);

  useEffect(() => {
    const handleStorageChange = () => {
      const accessToken = localStorage.getItem('accessToken');
      setIsAuthenticated(!!accessToken);
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  if (loading) return null;

  return (
    <Layout>
      <Switch>
        <Route exact path="/">
          {isAuthenticated ? <Redirect to={currentPath} /> : <Redirect to="/login" />}
        </Route>
        <Route path="/admin" render={() => (isAuthenticated ? <Admin /> : <Redirect to="/login" />)} />
        <Route path="/login" render={() => (isAuthenticated ? <Redirect to={currentPath} /> : <Login />)} />
      </Switch>
    </Layout>
  );
}

export default MainPage;
